module.exports = __webpack_public_path__ + "static/media/ee.70c22744.svg";